<template>
    <div v-show="store.state.currentTab === 'Edit'" class="b3-menu-content">
        <h1 class="themed-title">{{t('edit project title','Edit Project')}}</h1>
        <div class="ul-tab-area">
            <span class="ul-tab" :class="editTab === 'about' ? 'ul-tab-active' : ''" @click="editTab = 'about'">{{t('about','About')}}</span>
            <span class="ul-tab" :class="editTab === 'details' ? 'ul-tab-active' : ''" @click="editTab = 'details'">{{t('details','Details')}}</span>
            <span class="ul-tab" :class="editTab === 'actions' ? 'ul-tab-active' : ''" @click="editTab = 'actions'">{{('actions','Actions')}}</span>
        </div>

        <div v-show="editTab === 'about'">
            <table class="details-table" v-show="editMode === 'show'">
                <tr>
                    <td class="padded-cell">{{t('project title text input','Project Title')}}</td>
                    <td class="content-cell">{{ title }}</td>
                </tr>
                <tr>
                    <td class="padded-cell">{{caps(t('tags','Tags'))}}</td>
                    <td>
                        <span v-if="this.tagStr.length">
                            <span
                                v-for="(tag, j) in this.tagStr.split(',')" :key="j"
                                class="tag-bubble"
                                :style="`background-color: ${getTagColor(tag)};`"
                            >
                                {{ tag }}
                            </span>
                        </span>
                        <span v-else>({{t('no tags','No tags')}})</span>
                    </td>
                </tr>
                <tr>
                    <td class="padded-cell">{{caps(t('description','Description'))}}</td>
                    <td class="content-cell">{{ description || t('no description', '(No description)')}}</td>
                </tr>
                <tr>
                    <td class="padded-cell">{{t('credits','Credits')}}</td>
                    <td class="content-cell">{{ credits || t('no credits', '(No credits)')}}</td>
                </tr>
                <tr>
                    <td class="padded-cell">{{t('beading instructions','Beading Instructions')}}</td>
                    <td class="content-cell">{{ instructions || t('no instructions', '(No instructions)')}}</td>
                </tr>
                <tr>
                    <button @click="editMode = 'edit'">{{t('edit','Edit')}}</button>
                </tr>
            </table>
            <div v-show="editMode === 'edit'">
                <div class="b3-form-option">
                    <label>{{t('project title text input','Project Title')}}</label>
                    <input v-model="title" type="text" maxlength="100" :placeholder="t('enter title placeholder', 'Enter title here')">
                </div>
                <div class="b3-form-option">
                    <label >{{caps(t('tags','Tags'))}}</label>
                    <input v-model="tagStr" type="text" maxlength="100" :placeholder="t('tags separated by commas', 'Tags separated by commas')">
                </div>
                <div class="b3-form-option">
                    <label>{{caps(t('description','Description'))}}</label>
                    <textarea v-model="description" :placeholder="t('enter description placeholder', 'Enter description here')"></textarea>
                </div>
                <div class="b3-form-option">
                    <label>{{t('credits','Credits')}}</label>
                    <textarea v-model="credits" :placeholder="t('enter credits placeholder', 'Enter credits here')"></textarea>
                </div>
                <div class="b3-form-option">
                    <label>{{t('beading instructions','Beading Instructions')}}</label>
                    <textarea v-model="instructions" :placeholder="t('beading instructions placeholder', 'Enter beading instructions here')"></textarea>
                </div>
                <div class="b3-form-option button-area">
                    <button @click="updateProjectDetails()">{{t('save changes', 'Save Changes')}}</button>
                    <button @click="editMode = 'show'" class="quiet-button">{{t('cancel', 'Cancel')}}</button>
                </div>
            </div>

        </div>
        <div v-show="editTab === 'details'">
            <div v-show="!store.state.plasticMode">
                <div class="b3-form-option">
                    <label>{{t('bead library selection','Bead Library')}}</label>
                    <select v-model="library">
                        <option
                            v-for="(element, index) in librariesToShow" :key="index"
                            :value="element.displayName"
                        >
                            {{ element.displayName}}
                        </option>
                    </select>
                </div>
                <div class="b3-form-option" v-show="!chosenPattern.noChangePattern">
                    <label>{{t('pattern selection','Pattern')}}</label>
                    <select v-model="pattern">
                        <option
                            v-for="(element, index) in patternsToShow" :key="index"
                            :value="element.displayName"
                            v-show="library === 'Fuse Beads' ? element.plastic: !element.plastic"
                        >
                            {{ element.displayName}}
                        </option>
                    </select>
                </div>
                <div v-show="showRenameColorsChoice()" class="b3-form-option">
                    <label>
                        {{t('rename styles question','Rename styles?')}}
                        <span class="tooltip">ⓘ<span class="tooltiptext">{{t('rename styles tip','This will replace the description of each swatch with a generic color description.')}}</span></span>
                    </label>
                    <input v-model="renameColors" type="checkbox" id="stripProductInfo">
                </div>
            </div>
            <div class="b3-form-option" v-show="!chosenPattern.noColumns">
                <label>{{t('rows number input','Rows')}}</label>
                <input v-model="rows" type="number" min="1" max="400" >
            </div>
            <div class="b3-form-option" v-show="!chosenPattern.noColumns">
                <label>{{t('columns number input','Columns')}}</label>
                <input v-model="columns" type="number" min="1" max="400">
            </div>
            <div class="b3-form-option" v-show="chosenPattern.noColumns">
                <label>{{t('size number input','Size')}}</label>
                <input v-model="size" type="number" min="1" :max="chosenPattern.rowLimit || 30">
            </div>
            <div v-show="!chosenPattern.noCustomBeadSize">
                <div class="b3-form-option">
                    <label>{{t('use custom bead size','Use custom bead size')}}</label>
                    <input v-model="showAdvancedOptions" type="checkbox">
                </div>
                <div class="my-highlighted-options" v-show="showAdvancedOptions">
                    <div class="b3-form-option">
                        <label>{{t('bead diameter number input','Bead diameter (mm)')}}</label>
                        <input v-model="diameter" type="number" min="0" max="50" step="0.01">
                    </div>
                    <div class="b3-form-option">
                        <label>{{t('bead width number input','Bead width (mm)')}}</label>
                        <input v-model="width" type="number" min="0" max="50" step="0.01">
                    </div>
                    <div>
                        <span>{{t('aspect ratio','Aspect ratio:')}}&nbsp;</span>
                        <span>{{ beadDimensions.aspectRatio.toFixed(2) }}</span>
                    </div>
                    <div class="aspect-ratio-warning" v-show="showAspectRatioWarning">
                        {{t('aspect ratio warning','Bead width must be between 50-100% of bead diameter.')}}
                    </div>
                </div>
            </div>
            <div class="b3-form-option">
                <label>{{t('project size title','Project size')}}</label>
                <span>
                    {{ cmToInches(projectWidth) }} x {{ cmToInches(projectHeight) }} {{ t('inches') }}
                </span>
            </div>
            <div class="b3-form-option">
                <label></label>
                <span>
                    {{ projectWidth }} x {{ projectHeight }} {{ t('cm') }}
                </span>
            </div>
            <div v-if="rows * columns > 60000" class="warning">
                {{t('size warning','⚠️ This will be a large project. Beadographer may run slowly, depending on device memory.')}}
            </div>
            <div v-if="showChangePatternWarning()" class="warning">
                ⚠️ {{ t('change pattern warning', 'Changing patterns may result in lost beads. Please duplicate your project to back up your file before proceeding.') }}
            </div>
            <div v-if="showDeleteBeadsWarning()" class="warning">
                ⚠️ {{ t('delete beads warning', 'Beads may be deleted. This cannot be undone.') }}
            </div>
            <div class="b3-form-option">
                <button @click="updateProject({reload: true})">{{t('update project button','Update Project')}}</button>
                <span class="tooltip">ⓘ<span class="tooltiptext">{{t('update project button tip','You must click this button to apply any changes you made above.')}}</span></span>
            </div>
        </div>
        <div v-show="editTab === 'actions'">
            <div v-if="store.state.userImageFileName">
                {{t('canvas image', 'Canvas Image')}}: {{ store.state.userImageFileName }}
                <button class="mini-button nudge-down-2" @click="removeImage">
                    <Icon icon="delete"/>
                </button>
            </div>
            <div v-else>
                <button type="button">
                    <label class="custom-file-button">
                        <span for="load-image">{{t('load image button','Load Image')}}</span>
                        <input class="hidden" id="load-image" type="file" @change="readImage" accept="image/*"/>
                    </label>
                </button>
            </div>
            <div v-show="!chosenPattern.noColumns">
                <button @click="trim">{{t('trim project button','Trim Project')}}</button>
                <span class="tooltip">ⓘ<span class="tooltiptext">{{t('trim project button tip','Removes any empty rows and columns around your project.')}}</span></span>
            </div>
            <div v-if="loggedIn">
                <button @click="downloadProject">{{t('download project','Download Project')}}</button>
            </div>
            <div v-if="loggedIn">
                <button @click="duplicateProject">{{t('duplicate project', 'Duplicate Project')}}</button>
            </div>
            <div v-if="isStar">
                <button @click="copyFrontToBack">{{t('copy front to back','Copy Front to Back')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { libraries } from '../../myapp/src/libraries.js';
import { patterns } from '../../myapp/src/patterns/patterns.js';
import { settings } from '../../myapp/src/settings.js';
import { trim } from '../../myapp/src/procedures/trim.js';
import { menu } from '../../myapp/src/menu';
import { caps } from '../../myapp/src/lang';
import { utils } from '../../myapp/src/utils';
import { save } from '../../myapp/src/projects/save';
import { lang } from '../../myapp/src/lang';
import { userimage } from '../../myapp/src/tools/userimage';
import Icon from '../Icon.vue';

export default {
    data() {
        return {
            loggedIn,
            libraries: libraries,
            patterns: patterns.arr,
            showSizeWarning: false,
            library: 'Miyuki Delica 11/0',
            pattern: 'Loom',
            rows: 30,
            columns: 30,
            size: 5,
            title: '',
            tagStr: '',
            description: '',
            credits: '',
            instructions: '',
            width: 1,
            diameter: 1,
            showAdvancedOptions: false,
            renameColors: false,
            editTab: 'about',
            editMode: 'show'
        }
    },
    components: { Icon },
    computed: {
        chosenPattern: function () {
            return this.patterns.find(element => element.displayName === this.pattern);
        },
        chosenLibrary: function () {
            return this.libraries.find(element => element.displayName === this.library);
        },
        librariesToShow: function () {
            return this.libraries.filter(element => element.shape !== 'plastic');
        },
        patternsToShow: function () {
            return this.patterns.filter(element => element.noChangePattern !== true);
        },
        myLayout: function () {
            return patterns.getRowsAndColumns({
                pattern: this.chosenPattern,
                rows: this.rows,
                columns: this.columns,
                size: this.size
            });
        },
        beadDimensions: function () {
            const diameter = this.showAdvancedOptions ?
                this.diameter :
                this.chosenLibrary.diameter;

            const width = this.showAdvancedOptions ?
                this.width :
                this.chosenLibrary.width

            const aspectRatio = diameter / width;

            return { diameter, width, aspectRatio }
        },
        ignoreLastRow: function () {
            if (this.chosenPattern.name.slice(0, 6) !== 'peyote') return false;
            return this.rows % 2 === 1;
        },
        showAspectRatioWarning: function () {
            return (this.beadDimensions.aspectRatio < 1 || (this.beadDimensions.aspectRatio > 2));
        },
        dimensions: function () {
            return this.chosenPattern.getDimensions(
                this.myLayout.rows,
                this.myLayout.columns,
                this.beadDimensions.diameter,
                this.beadDimensions.width
            );
        },
        projectWidth: function () {
            return this.dimensions.width.toFixed(2);
        },
        projectHeight: function () {
            return this.dimensions.height.toFixed(2);
        },
        isStar: function () {
            return this.pattern === 'Peyote Star'
        },
    },
    methods: {
        trim, caps,
        copyFrontToBack() {
            b3.copyFrontToBack();
            const msg = this.t('front copied to back', 'Front copied to back');
            menu.showInfoBox({msg});
        },
        readImage() {
            userimage.readImage('load-image');
        },
        removeImage() {
            userimage.remove()
        },
        getTagColor: utils.getTagColor,
        cmToInches(num) {
            return (Number(num) / 2.54).toFixed(2);
        },
        showRenameColorsChoice() {
            return this.library !== settings.library?.displayName;
        },
        showDeleteBeadsWarning: function () {
            if (!this.store.state.startedApp) return false;
            return this.myLayout.rows < settings.rows || this.myLayout.columns < settings.columns;
        },
        updateProject({reload}) {
            menu.alterProject({
                chosenLibrary: this.chosenLibrary,
                chosenPattern: this.chosenPattern,
                title: this.title,
                tags: utils.processUserInputTagStr(this.tagStr),
                description: this.description,
                instructions: this.instructions,
                credits: this.credits,
                diameter: this.beadDimensions.diameter,
                width: this.beadDimensions.width,
                rows: this.myLayout.rows,
                ignoreLastRow: this.ignoreLastRow,
                beadDisplayHeight: utils.getBeadDisplayHeight({aspectRatio: this.beadDimensions.aspectRatio}),
                columns: this.myLayout.columns,
                renameColors: this.renameColors,
                reload
            });
        },
        updateProjectDetails() {
            const shouldUpdateTagList = this.tagStr !== settings.tags.join(', ');
            save.updateProjectMetaData({
                title: this.title,
                description: this.description,
                instructions: this.instructions,
                credits: this.credits,
                tags: utils.processUserInputTagStr(this.tagStr),
                shouldUpdateTagList
            });
            this.editMode = 'show';
        },
        reset() {
            if (!this.store.state.hasBooted) {
                return;
            }
            this.title = settings.title;
            this.description = settings.description;
            this.pattern = settings.pattern.displayName;
            this.library = settings.library.displayName;
            this.credits = settings.credits;
            this.instructions = settings.instructions;
            this.tagStr = settings.tags.join(', ');

            const [myRows, myColumns] = menu.getDisplayRowsAndColumns();

            this.rows = myRows;
            this.columns = myColumns;
            this.size = myRows;

            this.showAdvancedOptions = this.usingCustomBeadSize();

            this.diameter = settings.diameter;
            this.width = settings.width;
            this.editTab = 'about';
        },
        usingCustomBeadSize() {
            if (this.store.state.plasticMode) return false;
            if (settings.diameter !== this.chosenLibrary.diameter) return true;
            if (settings.width !== this.chosenLibrary.width) return true;
            return false;
        },
        showChangePatternWarning() {
            return this.pattern !== settings.pattern?.displayName;
        },
        downloadProject() {
            save.downloadById(settings.currentProjectId);
        },
        duplicateProject() {
            const doDuplicate = () => {
                save.duplicate({
                    selectedFile: {id: settings.currentProjectId},
                    title: this.store.state.dialogBox.textInputValue
                });
                b3.store.mySet('showingModal', null);
                b3.hideModal();
            };

            const prompt = lang.get('name duplicate prompt', 'Enter name of copy')

            b3.renderModal(prompt, doDuplicate, null, true);
        }
    },
    mounted() {
        this.ee.on('launchMenu', () => {
            this.reset();
        });
        this.ee.on('resetEditProjectModal', () => {
            this.reset();
        });
    }
}
</script>

<style lang="scss">
@import '../../assets/colors.scss';

.my-highlighted-options {
    padding: 5px 10px 10px 10px;
    background-color: white;
}
.aspect-ratio-warning {
    color: $warning;
    font-weight: bold;
}
.code-area {
    font-size: 20px;
}
.details-table {
    border-spacing: 0 10px;
    .padded-cell {
        padding: 5px 10px;
    }
    .content-cell {
        background-color: white;
        padding: 5px 10px;
        border-radius: 5px;
    }
}
</style>